module.exports = __webpack_public_path__ + "static/media/Doctor.566a85b5.png";